import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Funnel_Display\",\"arguments\":[{\"variable\":\"--font-funnel-sans\",\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\"]}],\"variableName\":\"funnelDisplay\"}");
;
import(/* webpackMode: "eager", webpackExports: ["IframeProvider"] */ "/app/src/context/IframeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StorefrontThemeProvider"] */ "/app/src/lib/theme/storefront-theme-context.tsx");
